//region 1. Platform Libraries
import express from 'express';
//endregion

//region 2. Project Libraries
import checkObjectID from '../middleware/checkObjectID';
import checkStreamIndex from '../middleware/checkStreamIndex';
import DataAPI from '../DataAPI';
//endregion

const context = {
    router: express.Router({ mergeParams: true }),
    recorders: null,
    logger: null,
};

context.router.get('/', checkObjectID);
context.router.get('/', checkStreamIndex);
context.router.get('/:module', (req, res) => {
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `GET ${req.originalUrl}` });
    log('debug', JSON.stringify(req.params, null, 2));
    if (['archive', 'live', 'event'].indexOf(req.params.module) === -1) {
        const message = 'Invalid Module Name';
        log('error', message);
        res.status(400).send(message);
        return;
    }
    const expired = new Date(Date.now() - ((DataAPI.heartbeatInterval + 3) * 1000));
    context.recorders.find({
        module: req.params.module,
        updated: { $gt: expired },
    }, {
        fields: { load_history: 0 },
        sort: { cpu_load: 1 },
    }).toArray((findErr, activeRecorders) => {
        if (findErr) {
            log('error', findErr.message);
            res.status(500).send(findErr.message);
            return;
        }
        if (activeRecorders.length === 0) {
            const message = `${req.params.module.toUpperCase()} Recorder Not Available`;
            log('error', message);
            res.status(500).send(message);
            return;
        }
        const max = Math.floor(activeRecorders.length / 2);
        const selected = activeRecorders[Math.floor(Math.random() * max)];
        const reply = {
            host: selected.private_ip,
            port: parseInt(selected.port, 10),
        };
        log('debug', JSON.stringify(reply, null, 2));
        log('info', '200 OK');
        res.status(200).send(reply);
    });
});

//noinspection JSUnusedGlobalSymbols
/**
 * Mount router for /c/:/s/:/new-recorder
 * @param {object}         options          Options
 * @param {object}         options.app      Express App
 * @param {MongoClient.Db} options.database Associated Database
 * @param {winston.Logger} options.logger   Logger
 */
export default function mountNewRecorder(options) {
    context.logger = options.logger;
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: 'mountNewRecorder' });
    log('debug', 'Mounting router for /c/:/s/:/new-recorder....');
    options.app.use('/cameras/:id/streams/:index/new-recorder', context.router);
    context.recorders = options.database.collection('recorders');
    log('info', 'Router for /c/:/s/:/new-recorder Mounted');
}
